export default __webpack_public_path__ + "locales/ru/PeopleTranslations.json?hash=65a9cde5dc1fb55ca7be987c1ea8c147";